module.exports = __webpack_public_path__ + "img/sign-out.ba5b84be.svg";